import React, { useState, useRef, useEffect } from "react";

function Hero() {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const playerRef = useRef(null);
  const iframeRef = useRef(null);

  useEffect(() => {
    // Load Vimeo Player API
    const script = document.createElement("script");
    script.src = "https://player.vimeo.com/api/player.js";
    script.async = true;
    
    script.onload = () => {
      // Initialize Vimeo Player after script loads and iframe is ready
      if (window.Vimeo && iframeRef.current) {
        playerRef.current = new window.Vimeo.Player(iframeRef.current);
        
        // Set volume to 100% and unmute when ready
        playerRef.current.ready().then(async () => {
          try {
            await playerRef.current.setVolume(1);
            await playerRef.current.setMuted(false);
            // Verify the settings
            const volume = await playerRef.current.getVolume();
            const muted = await playerRef.current.getMuted();
            console.log("Video ready - Volume:", volume, "Muted:", muted);
            setIsReady(true);
          } catch (error) {
            console.error("Error setting initial video settings:", error);
            setIsReady(true); // Still allow play even if settings fail
          }
        });

        // Listen for play/pause events and ensure unmuted on play
        playerRef.current.on('play', async () => {
          setIsPlaying(true);
          // Ensure video is unmuted when it starts playing
          try {
            await playerRef.current.setMuted(false);
            await playerRef.current.setVolume(1);
          } catch (error) {
            console.error("Error ensuring video is unmuted:", error);
          }
        });
        playerRef.current.on('pause', () => setIsPlaying(false));
      }
    };
    
    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  const handlePlay = async () => {
    if (playerRef.current && isReady) {
      try {
        // Ensure video is unmuted and volume is set before playing
        await playerRef.current.setMuted(false);
        await playerRef.current.setVolume(1);
        // Small delay to ensure settings are applied
        await new Promise(resolve => setTimeout(resolve, 100));
        await playerRef.current.play();
        // Double-check unmuted state after play
        await playerRef.current.setMuted(false);
        await playerRef.current.setVolume(1);
        setIsPlaying(true);
      } catch (error) {
        console.error("Error playing video:", error);
      }
    }
  };

  const handlePause = async () => {
    if (playerRef.current) {
      try {
        await playerRef.current.pause();
        setIsPlaying(false);
      } catch (error) {
        console.error("Error pausing video:", error);
      }
    }
  };

  return (
    <section
      className="w-100 d-flex align-items-end justify-content-center mt-5 position-relative"
      id="home"
    >
      {/* Vimeo Video Embed */}
      <div
        className="w-100 position-relative"
        style={{
          paddingBottom: "56.25%", // 16:9 aspect ratio
          height: 0,
          overflow: "hidden",
          zIndex: -1,
        }}
      >
        <iframe
          ref={iframeRef}
          src="https://player.vimeo.com/video/1134238219?loop=1&muted=0&controls=0&title=0&byline=0&portrait=0"
          className="position-absolute top-0 left-0 w-100 h-100"
          style={{
            border: "none",
            objectFit: "contain",
          }}
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          title="WellSole Introduction Video"
        ></iframe>
      </div>

      {/* Play/Pause Button Overlay */}
      <div
        className="position-absolute"
        style={{
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 10,
        }}
      >
        {!isPlaying ? (
          <button
            onClick={handlePlay}
            className="btn btn-primary"
            style={{
              borderRadius: "50%",
              width: "80px",
              height: "80px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 15px rgba(0, 0, 0, 0.3)",
              border: "none",
              cursor: "pointer",
            }}
            aria-label="Play video"
            disabled={!isReady}
          >
            <i className="uil uil-play" style={{ fontSize: "32px", marginLeft: "4px" }}></i>
          </button>
        ) : (
          <button
            onClick={handlePause}
            className="btn btn-primary"
            style={{
              borderRadius: "50%",
              width: "80px",
              height: "80px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 15px rgba(0, 0, 0, 0.3)",
              border: "none",
              cursor: "pointer",
            }}
            aria-label="Pause video"
          >
            <i className="uil uil-pause" style={{ fontSize: "32px" }}></i>
          </button>
        )}
      </div>

      {/* <div className="rounded-5 title-heading text-center studio-home rounded white-transparent-bg mb-3">
        <h2 className=" fw-bolder mb-1">
          Optimize Your Performance and Wellness with <br/>
          <span className="clr">WellSole AI Smart Insoles</span>
        </h2>
        <div className="mt-1 text-center">
          <Link to="/contact" className="btn btn-primary">
            <i className="uil uil-phone"></i> Contact Us
          </Link>
        </div>

      </div> */}
    </section>
  );
}

export default Hero;
